import { registerCondition } from 'core/forms';

const isNotFileUpload = ({ model }) => ({
  hasCondition: model.source_content_type !== 'file_upload',
  condition: null,
});

registerCondition('isNotFileUpload', isNotFileUpload);

export default isNotFileUpload;
